/** С возвращением: офлайн-доход и серия — чистая модель без DOM. */
import { type BalanceData, type PlayerState } from "@newfungame/contracts";
import { type StreakDayView, streakDays } from "../streak/model";

export interface WelcomeBackModel {
  coins: number;
  /** Сколько секунд держался штаб (не больше потолка). */
  awaySeconds: number;
  capSeconds: number;
  /** Заполненность склада, промилле 0…1000. */
  storagePermille: number;
  /** Через сколько секунд склад заполнится (0 — уже полон). */
  fullInSeconds: number;
  streak: StreakDayView[];
  streakDay: number;
  /** Награду серии можно забрать сейчас — «Забрать всё» заберёт и её. */
  streakClaimable: boolean;
}

export function welcomeBackModel(b: BalanceData, p: Pick<PlayerState, "offline" | "streak">): WelcomeBackModel {
  const cap = Math.max(0, p.offline.capSeconds);
  const away = Math.min(Math.max(0, p.offline.seconds), cap);
  return {
    coins: p.offline.coins,
    awaySeconds: away,
    capSeconds: cap,
    storagePermille: cap > 0 ? Math.floor((away * 1000) / cap) : 1000,
    fullInSeconds: cap - away,
    streak: streakDays(b, p.streak),
    streakDay: p.streak.day,
    streakClaimable: !p.streak.claimedToday,
  };
}

/** Часы и минуты для «6 ч 20 мин» (минуты вниз). */
export function splitDuration(seconds: number): { h: number; m: number } {
  const total = Math.max(0, Math.floor(seconds / 60));
  return { h: Math.floor(total / 60), m: total % 60 };
}
